import { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const PageContext = createContext();

export function Provider({ children, value }) {
  const { pageName: defaultPageName } = value;
  const [pageName, setPageName] = useState(defaultPageName);

  return (
    <PageContext.Provider value={{ pageName, setPageName }}>
      {children}
    </PageContext.Provider>
  );
}

Provider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.shape({
    pageName: PropTypes.string,
  }),
};

Provider.defaultProps = {
  children: undefined,
  value: {},
};

export default PageContext;
